import { Tooltip } from '@mantine/core'
import { Copy } from 'lucide-react'

import { toast } from 'src/components/Overlays/Toast/Toast'

interface IdCellProps {
  taskTemplateId: string
}

const IdCell = ({ taskTemplateId }: IdCellProps) => {
  const onCopy = () => {
    navigator.clipboard.writeText(taskTemplateId)
  }

  return (
    <Tooltip label={taskTemplateId}>
      <Copy
        size={12}
        className="stroke-doubleNickel-gray-600"
        onClick={(e) => {
          e.stopPropagation()
          onCopy()
          toast('Copied to clipboard!', 'success')
        }}
      />
    </Tooltip>
  )
}

export default IdCell
